var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.selectedOffers),function(offer,index){return [_c(_setup.OfferDetailsShort,{key:offer?.info?.id,attrs:{"user-input":_vm.userInput,"offer":offer}}),_vm._v(" "),(index !== _vm.selectedOffers.length - 1)?_c('v-divider',{key:`divider${offer?.info?.id}`,staticClass:"mb-4"}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }